import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../App.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('@/views/Error.vue'),
  },
  {
    path: '*',
    redirect: '/error',
  },
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
